const ABSOLUTE_URL = /^(?:[a-z][a-z\d+\-.]*:)?\/\//i;

export function isAbsoluteUrl(url: string): boolean {
  return ABSOLUTE_URL.test(url);
}

export function isThirdPartyUrl(url: string, apiUrl: string | undefined): boolean {
  if (!isAbsoluteUrl(url)) {
    return false;
  }

  if (!apiUrl) {
    return true;
  }

  return !url.startsWith(apiUrl);
}
